import type {DataValue, LinkedValue} from '../types';
import { LinkStatuses} from '../types';
import {isData} from './isData';

export const isLinkedValue = (
  value: DataValue | undefined,
): value is LinkedValue =>
  isData(value) &&
  LinkStatuses.includes((value as LinkedValue).link?.linkStatus ?? '');
